import React from "react";
import { Route, Redirect } from "react-router-dom";
import { checkTokenExpirationMiddleware } from './users-auth.middleware';

export const ProtectedRoute = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (checkTokenExpirationMiddleware() != null) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location
                }
              }}
            />
          );
        }
      }}
    />
  );
};
